import React, { useState, useEffect, useCallback } from "react";
import { withRouter } from 'react-router-dom';
import { Col, FormGroup, Form, Label, Table, Modal, Input } from "reactstrap";
import { PostCertificate, GetCertificateList, downloadCertificate } from 'action/secureconnectAction';
import { Icon } from 'semantic-ui-react';
import { Button } from "@material-ui/core";
import {
    ModelBodyDiv, StyledRowDiv, HeaderTitle, CheckBoxDiv, FileSelectionDiv, FileNameInput, ErrorSectionDiv,
    TextAreaWrapper, HyperLinkDiv, CloseButton, CorrectAllError, FooterButtons, CertDetailsTable, EditButton
} from "./styled";
import { setAmplitudeEvent } from 'amplitude/amplitude';
import { useDispatch, useSelector } from "react-redux";
import { useCertificateDeleteAPIMethods, useGetLocalizationLabel, useFetchHubParamsData } from "./useAPIMethods";
import { getInstanceType } from '../../../../../action/Administration/license';
import { FaArrowLeft } from "react-icons/fa";
import Spinner from "components/common/LegacySpinner";
import {
    DeleteIconWrapper, ErrorIcon, ErrorMessage, SaveButton, SpinnerContainer, StyledHRColumn, DownloadIconWrapper, HubParamModal

} from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect/styled";
import { BsTrash } from "react-icons/bs";
import { MdWarning, MdClose, MdGetApp } from "react-icons/md";
import { FormErrorContainer, ErrorSection, ErrorIconContainer, EditActions } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/styled";
import Tooltip from "components/common/Tooltip";
import { useDateTimeByUserFormat } from "utils";
import EditSignCertificate  from "./EditCertificateDetails";
import InactiveWindow from '../../../../Logout/InActive';
import Idle from 'react-idle';

const ManageSignCertificate = ({ history }) => {
    const dispatch = useDispatch();
    const certificateList = useSelector(state => state.HubManagementRootReducer.certificateList);
    const isCloud = useSelector(state => state.InstallationsRootReducer.IsCloud);
    const [state, setState] = useState({
        isModelOpen: false,
        file: "",
        fileName: "",
        needChainOfCertificate: true,
        description: "",
        error: false,
        apiError: "",
        errorResponseText: "",
        deleteItem: null,
        loading: true,
        isCAModelOpen: false,
        isEdit: false,
        inactive_modal: false,
        LogOffTime: 1200000,
    });
    const { getDateTimeValue } = useDateTimeByUserFormat();
    const { getCertificateDetail, downloadRootCertificate, certificateDetails, data, refetch } = useFetchHubParamsData(history);
    const getCertificateData = (suppressError) => {
        dispatch(GetCertificateList((apiStatus, errorDetails) => getCertListCallback(apiStatus, errorDetails, suppressError)));
    }
    const { deleteCertificate } = useCertificateDeleteAPIMethods(setState, getCertificateData);

    const { getLabel, getErrorLabel } = useGetLocalizationLabel(); // do we need seperate calling for localizationlabel?

    // **** For componentDidMount method ***** //
    useEffect(()=>{
        setAmplitudeEvent("ManageSignCertificatePage", { "user": "admin", "action": "Navigated to Manage Sign Certificate page" });
        getCertificateData();
        getCertificateDetail(state, true);
        dispatch(getInstanceType());
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
           setState(prevState => ({...prevState, LogOffTime : Number(E_LogoffTime) }));
        }
        const fetchUpdatedData = setInterval(() => {
            getCertificateData(true);
        }, 10000);
        return () => {
            clearInterval(fetchUpdatedData);
        }
    }, []);

    useEffect(() => {
        if (state.deleteItem) {
            setState(prevState => ({
                ...prevState,
                isModelOpen: true,
            }));
        }
    }, [state.deleteItem]);

    useEffect(() => {
      getCertificateDetail();
      refetch({}, true);
    },[state.isEdit])

    const getCertificateName = (originalName, onlyName) => {
        let updatedName = originalName;
        if (updatedName) {
            if (updatedName.split(" ")[0].includes("CN=")) {
                updatedName = updatedName.split(" ")[0].replace("CN=", "").replace(",", "");
            } else {
                updatedName = updatedName.split(" ")[1].replace("CN=", "").replace(",", "");
            }
            if (onlyName) {
                updatedName = `${updatedName}`;
            } else {
                updatedName = `${getLabel("CertificateDetails") ? getLabel("CertificateDetails") : "Certificate Details for"} ${updatedName}`;
            }
        } else {
            updatedName = "--";
        }
        return updatedName;
    }
    const getCertListCallback = (status, errorDetails, suppressError) => {
        if (suppressError) {
            setState(prevState => ({ ...prevState, loading: false }));
        } else {
            setState(prevState => ({ ...prevState, apiError: status === "error" ? errorDetails.message : "", loading: false }));
        }
    };
    const onClickCertificateName = (certificateId) => {
        setState(prevState => ({ ...prevState, selectedCertificate: certificateId, isCAModelOpen: !prevState.isCAModelOpen }));
    }

    const onToggleCAModel = () => {
        setState(prevState => ({
            ...prevState,
            isCAModelOpen: !prevState.isCAModelOpen
        }));
    }

    const onClickDownloadCertificate = useCallback((certificateId, fileName) => {
        downloadCertificate(certificateId, fileName);
    }, []);

    const onClickFileSelection = (e) => {
        e.preventDefault();
        const fileTypes = ['csr', 'pem', 'req'];
        setState(prevState => ({
            ...prevState,
            error: false,
            errorMessage: ""
        }));
        if (e.target.files && e.target.files[0]) {
            const extension = e.target.files[0].name.split('.').pop().toLowerCase(),  //file extension from input file
                fileTypeSuccess = fileTypes.indexOf(extension) > -1;
            if (fileTypeSuccess) {
                const reader = new FileReader();
                const file = e.target.files[0];
                reader.onloadend = () => {
                    setState(prevState => ({
                        ...prevState,
                        fileName: file.name,
                        file: file,
                        description: file.name
                    }));
                }
                reader.readAsDataURL(file);
            } else {
                setState(prevState => ({
                    ...prevState,
                    error: true,
                    errorMessage: getLabel("OnlyCSRAllowed") ? getLabel("OnlyCSRAllowed") : "Only .csr, .pem and .req extension files are allowed"
                }));
            }
        }
    }

    const onToggleModel = () => {
        setState(prevState => ({
            ...prevState,
            isModelOpen: !prevState.isModelOpen,
            file: "",
            fileName: "",
            filePreviewUrl: "",
            needChainOfCertificate: true,
            error: false,
            errorMessage: "",
            deleteItem: null,
            description: ""
        }));
    }

    const uploadFileCallback = (status, error) => {
        if (status === "success") {
            getCertificateData();
            onToggleModel();
            setState(prevState => ({
                ...prevState,
                loading: false,
                file: ""
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                apiError: error.errorCode ? `Error: ${getErrorLabel(error.errorCode)}` : error.message,
                loading: false
            }));
        }
    }

    const onSubmitFile = () => {
        const { file, needChainOfCertificate, description } = state;
        if (file !== "") {
            setState(prevState => ({
                ...prevState,
                loading: true,
                apiError: ""
            }));
            const data = new FormData();
            data.append("file", file);
            data.append("needChainOfCertificate", needChainOfCertificate);
            data.append("description", description);
            dispatch(PostCertificate(data, uploadFileCallback));
        } else {
            setState(prevState => ({
                ...prevState,
                error: true,
                errorMessage: getLabel("NoFile") ? getLabel("NoFile") : "No file selected"
            }));
        }
    }

    const onChangeCheckbox = (e) => {
        const isChecked = e.target.checked;
        setState(prevState => ({
            ...prevState,
            needChainOfCertificate: isChecked
        }));
    }

    const onChangeDescription = (event) => {
        const value = event.target.value;
        setState(prevState => ({ ...prevState, description: value }));
    }

    const getCSRFileUploadComponent = () => {
        const { fileName, error, errorMessage, description } = state;
        return (
            <ModelBodyDiv>
                <HeaderTitle id="uploadCA-header-title">
                    <Label>{getLabel("UploadModalTitle") ? getLabel("UploadModalTitle") : "Upload Certificate Signing Request"}</Label>
                </HeaderTitle>
                {
                    state.error ? <CorrectAllError>
                        <ErrorIcon /><b>{getLabel("CorrectAllError") ? getLabel("CorrectAllError") : "Please correct all errors before continuing."}</b>
                    </CorrectAllError> : null
                }
                <StyledRowDiv>
                    <hr />
                </StyledRowDiv>
                <CheckBoxDiv>
                    <Input type="checkbox" id="need-chain-of-cert" checked={state.needChainOfCertificate} onChange={onChangeCheckbox} />
                    <Label for="need-chain-of-cert">{getLabel("NeedChainCertificate") ? getLabel("NeedChainCertificate") : "Include full certificate chain"}</Label>
                </CheckBoxDiv>
                <FileSelectionDiv error={error}>
                    <Label className="label-name">{getLabel("CSRFileName") ? getLabel("CSRFileName") : "CSR File Name: "}</Label>
                    <FileNameInput value={fileName} />
                    { 
                        error ? <ErrorSectionDiv ml="0px">
                            <Icon name='exclamation triangle' />
                        </ErrorSectionDiv> : null
                    }
                    <Label id="choice-file" for="csr-file-input">{getLabel("ChooseFile") ? getLabel("ChooseFile") : "Choose File"}
                        <Input
                            type="file"
                            id="csr-file-input"
                            onChange={onClickFileSelection}
                        />
                    </Label>
                    {
                        error ? <ErrorSectionDiv>
                            <Label>{errorMessage}</Label>
                        </ErrorSectionDiv> : null
                    }
                </FileSelectionDiv>
                <TextAreaWrapper>
                    <Label className="label-name">{getLabel("Description:") ? getLabel("Description:") : "Description: "}</Label>
                    <textarea
                        type="text"
                        id="csr-file-description"
                        name="csr-file-description"
                        rows="4" cols="53"
                        maxLength={300}
                        value={description}
                        onChange={onChangeDescription}
                    />
                </TextAreaWrapper>
                <CloseButton id="close-button" mr="0" onClick={onToggleModel} variant="contained">{getLabel("Close") ? getLabel("Close") : "Close"}</CloseButton>
                <SaveButton id="submit-button" onClick={onSubmitFile} variant="contained" primary>{getLabel("Submit") ? getLabel("Submit") : "Submit"}</SaveButton>
            </ModelBodyDiv>
        );
    }

    const getErrorTooltip = (rowObj = {}) => {
        if (rowObj.errorCode && rowObj.errorCode !== 0 && rowObj.errorCode !== "0") {
            return (<Tooltip id="tooltip-icon"
                title={getErrorLabel(rowObj.errorCode) ? getErrorLabel(rowObj.errorCode)
                    : rowObj.errorDesc ? rowObj.errorDesc : "Unknown error"}
                placement="right">
                <ErrorIconContainer>
                    <MdWarning />
                </ErrorIconContainer>
            </Tooltip>);
        } else {
            return null;
        }
    }

    const getCertificateDetails = () => {
        let certificateDetail = null;
        if (certificateList && certificateList.length) {
            certificateDetail = certificateList.map(el => (
                <tr key={el.CertificateID}>
                    <td style={{ padding: "5px 11px" }}>{el.certSubject ? el.certSubject : "CN="}</td>
                    <td style={{ padding: "5px 11px" }}>
                        {el.status ? el.status : "--"} {getErrorTooltip(el)}
                    </td>
                    <td style={{ padding: "5px 11px" }}>{el.status === "Success" ? getDateTimeValue(el.validFrom) : "--"}</td>
                    <td style={{ padding: "5px 11px" }}>{el.status === "Success" ? getDateTimeValue(el.validTo) : "--"}</td>
                    <td style={{ padding: "5px 11px" }}>{el.description ? el.description : "--"}</td>
                    <td style={{ padding: "5px 11px" }}>
                        <DownloadIconWrapper
                            id="download-icon"
                            fontSize={"21px"}
                            pt="4px"
                            pl="17px"
                            disabled={el.status !== "Success"}
                            onClick={el.status !== "Success" ? () => null : () => { onClickDownloadCertificate(el.certificateID, el.signedCertFileName) }}
                            title="Click to download certificate"
                        >
                            <MdGetApp />
                        </DownloadIconWrapper>
                    </td>
                    <td >
                        <DeleteIconWrapper
                            id="delete-icon"
                            onClick={() => onClickDelete(el)}
                            title="Delete certificate"
                        >
                            <BsTrash />
                        </DeleteIconWrapper>
                    </td>
                </tr>
            ));
        } else {
            certificateDetail = <tr>
                <td colSpan="7" style={{ textAlign: "Center" }}>{getLabel("NoRecords") ? getLabel("NoRecords") : "No Records Found"}</td>
            </tr>
        }
        return certificateDetail;
    }

    const onClickDeleteYes = () => {
        if (state.deleteItem) {
            deleteCertificate(state.deleteItem.certificateID);
        }
    }

    const showCertificateDetails = () => {
        const { selectedCertificate } = state;
        let title = "--", certificateName = "--";
        const details = (selectedCertificate === "rootCert" && certificateDetails) ? certificateDetails : null;
        if (selectedCertificate === "rootCert" && certificateDetails !== undefined && certificateDetails !== null) {
            title = getCertificateName(certificateDetails.certSubject);
            certificateName = certificateDetails.certSubject ? certificateDetails.certSubject : "--";
        }

        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <div onClick={onToggleCAModel}><MdClose /></div>
                    <label style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}>{title}</label>
                </HeaderTitle>
                <CertDetailsTable>
                    <tbody>
                        <tr>
                            <td>{getLabel("DistinguishedName") ? getLabel("DistinguishedName") : "Distinguished Name"}</td><td>{certificateName}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("IssuedBy") ? getLabel("IssuedBy") : "Issued By"}</td><td>{details ? details.issuerCertificateSubjectName : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotBefore") ? getLabel("NotBefore") : "Not Before"}</td><td>{details ? getDateTimeValue(details.validFrom) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("NotAfter") ? getLabel("NotAfter") : "Not After"}</td><td>{details ? getDateTimeValue(details.validTo) : "--"}</td>
                        </tr>
                        <tr>
                            <td>{getLabel("Thumbprint") ? getLabel("Thumbprint") : "Thumbprint"}</td><td>{details ? details.thumbprint : "--"}</td>
                        </tr>
                    </tbody>
                </CertDetailsTable>
                <FooterButtons id="model-footer-section">
                    <EditActions>
                        {
                            selectedCertificate === "rootCert" ? <Button id="apply_button" variant="contained"
                                onClick={() => downloadRootCertificate(`${getCertificateName(certificateDetails.certSubject, true)}.pem`)}>{getLabel("Download") ? getLabel("Download") : "Download"}</Button> : null
                        }
                        <Button id="cancel_button" variant="contained" onClick={onToggleCAModel}>{getLabel("Close") ? getLabel("Close") : "Close"}</Button>
                    </EditActions>
                </FooterButtons>
            </ModelBodyDiv>
        );
    }
    const deleteWarningPopup = () => {
        return (
            <ModelBodyDiv>
                <HeaderTitle id="header-title">
                    <label>{getLabel("DeleteModalTitle") ? getLabel("DeleteModalTitle") : "Delete BACnet Secure Network"}</label>
                </HeaderTitle>
                <StyledHRColumn sm={{ size: 12 }} ml="0px">
                    <hr />
                </StyledHRColumn>
                <ErrorMessage>
                    <p>{getLabel("DeleteWarning") ? getLabel("DeleteWarning") : "Are you sure you want to delete the certificate ?"}</p>
                </ErrorMessage>
                <CloseButton id="close-button" onClick={onToggleModel} variant="contained">{getLabel("Cancel") ? getLabel("Cancel") : "Cancel"}</CloseButton>
                <SaveButton id="delete-button" primary onClick={onClickDeleteYes} variant="contained">{getLabel("Delete") ? getLabel("Delete") : "Delete"}</SaveButton>
            </ModelBodyDiv>
        );
    }

    const onClickDelete = (objectData) => {
        setState(prevState => ({ ...prevState, deleteItem: objectData }));
    }

    // const onClickBack = () => {
    //     window.location.href = `${window.location.origin}/TracerEnsemble/SystemAdmin/BACnetSecureConnect.aspx`;
    // }

    const SelectedModal = (deleteItem) => {
        if (deleteItem !== null)
            return deleteWarningPopup();
        else
            return getCSRFileUploadComponent()
    }

    const handleEditCASettings = () => {
        setState(prevState => ({...prevState, isEdit: true}));
    }

    const onCancel = () => {
        setState(prevState => ({
            ...prevState,
            isEdit: !prevState.isEdit
        }))
    }

    const Inactivetoggle = () => {
        setState(prevState => ({
             ...prevState,
             inactive_modal: !state.inactive_modal,
        }))
     }
 
     const Extend_Session = (someArg) => {
         Inactivetoggle();
     }

    return (
        <>
        {state.isEdit ? <EditSignCertificate getCertificateDetails={getCertificateDetails} certificateDetails={certificateDetails} data={data} onCancel={onCancel} isCloud={isCloud}/> :
        (data && (data.hubMode !== "2" || !data.isHubServerEnabled))? 
            <div className="main_container">
                 <div id="CAheader-label">
                    <h2 style={{ color: "black" }}>{getLabel("ManageCA") ? getLabel("ManageCA") : "Manage CA"}
                    </h2>
                </div>
                <Form>
                    <FormGroup row style={{ marginTop: "10px", marginLeft: "-14px " }}>
                        <Col sm={{ size:1 }}>
                            <Label style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}>{getLabel("Port") ? getLabel("Port") : "Port"}</Label>
                        </Col>
                        <Col sm={{ size:6 }}>
                            <Label style={{ color: "black" }}>{data && data.portNumber ? data.portNumber : "47808"}</Label>
                        </Col>
                        <Col sm={{ size:2 }}>
                            <EditButton id="cancel_button" variant="contained" primary ml="10px" width="158px" onClick={handleEditCASettings} style={{display: isCloud ? 'none': 'block'}}>{getLabel("EditPortSettings") ? getLabel("EditPortSettings") : "Edit Port Settings"}</EditButton>
                        </Col>
                    </FormGroup>
                </Form>
                <CloseButton id="close-button" mr="0" mt="15px" variant="contained" onClick={() => history.goBack()}><FaArrowLeft /> {getLabel("Back") ? getLabel("Back") : "Back"}</CloseButton>
            </div> : 
            <div className="main_container">
                <Modal isOpen={state.isModelOpen} toggle={onToggleModel}>
                    {
                        SelectedModal(state.deleteItem)
                    }
                </Modal>
                <HubParamModal
                    isOpen={state.isCAModelOpen}
                    toggle={onToggleCAModel}
                    id="view-hub-parameters-model"
                    isAlertModel={state.selectedCertificate}>
                    {
                        showCertificateDetails()
                    }
                </HubParamModal>
                <div id="CAheader-label" style={{ marginBottom: "1%" }}>
                    <h2 style={{ color: "black" }}>{getLabel("ManageCA") ? getLabel("ManageCA") : "Manage CA"}
                    </h2>
                </div>
                <Form>
                    <FormGroup row style={{ marginTop: "10px", marginLeft: "-14px ", marginBottom: "0.5%" }}>
                        <Col sm={{ size: 1 }} style={{ paddingRight: "0" }}>
                            <Label style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}>{getLabel("CACertificate") ? getLabel("CACertificate") : "CA Certificate"} </Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label>{certificateDetails && certificateDetails.certSubject ? 
                                <HyperLinkDiv id="rootCert-link" onClick={() => onClickCertificateName("rootCert")}>{certificateDetails.certSubject}</HyperLinkDiv> : "--"}
                            </Label>
                        </Col>
                        <Col sm={{ size: 2 }}>
                            <EditButton id="cancel_button" variant="contained" primary ml="10px" width="158px" onClick={handleEditCASettings}>{getLabel("EditCASettings") ? getLabel("EditCASettings") : "Edit CA Settings"}</EditButton>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ marginLeft: "-14px ", marginBottom: "0.5%" }}>
                        <Col sm={{ size: 1 }}>
                            <Label style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}>{getLabel("ExpiresOnCamelCase") ? getLabel("ExpiresOnCamelCase") : "Expires On"}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label style={{ color: "black" }}>{certificateDetails && certificateDetails.validTo ? getDateTimeValue(certificateDetails.validTo) : "--"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ marginLeft: "-14px", marginBottom: "0.5%" }}>
                        <Col sm={{ size:1 }}>
                            <Label style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}>{getLabel("Port") ? getLabel("Port") : "Port"}</Label>
                        </Col>
                        <Col sm={{ size:6 }}>
                            <Label style={{ color: "black" }}>{data && data.portNumber ? data.portNumber : "47808"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-top": "50px" }}>
                        <Col sm={{ size: 4 }} id="CSRheader-label">
                            <h2 style={{ color: "black" }}>{getLabel("HeaderTitle") ? getLabel("HeaderTitle") : "Manage CSRs"}</h2>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 3 }}>
                            <h3 style={{ float: 'left', fontWeight: "bold", color: "black",position:"relative" }} className="custom_label">{getLabel("BodyTitle") ? getLabel("BodyTitle") : "Operational Certificate Validity"}</h3>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label style={{ float: 'left', color: "black", margin: "2px 0px 10px 10px", position:"absolute" }} className="custom_lifetime">{data && data.oprCertValidityYear ? data.oprCertValidityYear + " Years" : "5 Years"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <Label style={{ color: "black", marginTop: "20px", fontSize: "17px", fontWeight: "bold" }}>{getLabel("DownloadTitle") ? getLabel("DownloadTitle") : "Upload Certificate Signing Request (CSR)"}</Label>
                        </Col>
                        <Col sm={{ size: 6 }} style={{"margin-top":"15px"}}>
                            <SaveButton id="submitCSR-button" onClick={onToggleModel} variant="contained" primary ml="5px" mb="12px" width="118px">{getLabel("SubmitCSR") ? getLabel("SubmitCSR") : "Submit CSR"}</SaveButton>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-top": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <Label style={{ color: "black" }}>{getLabel("HintText") ? getLabel("HintText") : "When a CSR is signed it becomes a Operational Certificate"}</Label>
                        </Col>
                    </FormGroup>
                </Form>
                <div className="table_container" style={{ height: "auto", minHeight: "150px" }}>
                    <Table id="table_Holidays" striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th style={{ padding: "8px 11px", width: "23%" }} className="link_cursor">{getLabel("SubjectName") ? getLabel("SubjectName") : "Subject Name"}</th>
                                <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("Status") ? getLabel("Status") : "Status"}</th>
                                <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("ValidFrom") ? getLabel("ValidFrom") : "ValidFrom"}</th>
                                <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("ValidTo") ? getLabel("ValidTo") : "ValidTo"}</th>
                                <th style={{ padding: "8px 11px", width: "33%" }} className="link_cursor">{getLabel("Description") ? getLabel("Description") : "Description"}</th>
                                <th style={{ padding: "8px 11px" }} className="link_cursor">{getLabel("Certificate") ? getLabel("Certificate") : "Certificate"}</th>
                                <th style={{ padding: "8px 11px" }} ></th>
                            </tr>
                            {getCertificateDetails()}
                        </tbody>
                    </Table>
                </div>
                {
                    state.apiError ? <ErrorSection>
                        <FormErrorContainer>
                            <MdWarning />
                            <b>{state.apiError}</b>
                        </FormErrorContainer>
                        <div>
                            <MdClose id="close-icon" onClick={() => setState(prevState => ({ ...prevState, apiError: "" }))} />
                        </div>
                    </ErrorSection> : null
                }
                {state.loading ? <SpinnerContainer>
                    <Spinner
                        loadingContent={state.fileName !== "" ? "Certificate being generated..." : undefined}
                        width={state.fileName !== "" ? "265px" : undefined}
                    />
                </SpinnerContainer> : null
                }
                <CloseButton id="back-button" mr="0" mt="15px" variant="contained" onClick={() => history.goBack()}><FaArrowLeft /> {getLabel("Back") ? getLabel("Back") : "Back"}</CloseButton>
            </div>
        }
        <Idle timeout={state.LogOffTime} onChange={({ idle }) => {
            if (idle) {
                setState(prevState => ({...prevState, inactive_modal: true}))
            }
        }} />
        <Modal isOpen={state.inactive_modal} className={"ModalContainer InActive_Short_Modal"} >
            <InactiveWindow Extend_Session={Extend_Session} />
        </Modal>
        </>
    );
};

export default withRouter(ManageSignCertificate);